var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99976 12L2.99976 7L4.39976 5.55L6.99976 8.15V0H8.99976V8.15L11.5998 5.55L12.9998 7L7.99976 12ZM1.99976 16C1.44976 16 0.979089 15.8043 0.587756 15.413C0.196422 15.0217 0.000422526 14.5507 -0.000244141 14V11H1.99976V14H13.9998V11H15.9998V14C15.9998 14.55 15.8041 15.021 15.4128 15.413C15.0214 15.805 14.5504 16.0007 13.9998 16H1.99976Z",
    fill: "#23479F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadicon);
export default __webpack_public_path__ + "static/media/downloadicon.e056f464f585add224b9c1613042a36f.svg";
export { ForwardRef as ReactComponent };